<!-- Desktop Sidebar (screen > 475px) -->
<ng-container *ngIf="screenWidth > 475">

  <div class="crm-container d-flex h-100">
    <!-- Main Sidebar -->
    <div class="main-sidebar" [ngClass]="{ 'collapsed': effectivelyCollapsed }" (mouseenter)="onSidebarMouseEnter()"
      (mouseleave)="onSidebarMouseLeave()">

      <!-- Closes any open popover on an outside click — a real DOM click target
           (not a document-bubbling check) so unrelated stopPropagation() calls
           elsewhere in the app can't swallow it before it reaches us. -->
      <div class="popover-backdrop" *ngIf="anyPopoverOpen && !isHoverOpened"(click)="closeAllPopovers()"></div>

      <!-- Header: business switcher + search/collapse icons -->
      <div class="sidebar-header">
        <div class="switcher-trigger" (click)="toggleBusinessSwitcher()">
          <div class="switcher-tile">
            <img *ngIf="bDetails?.logo" [src]="bDetails?.logo" alt="">
            <span *ngIf="!bDetails?.logo">{{ businessName?.charAt(0) | uppercase }}</span>
          </div>
          <ng-container *ngIf="!effectivelyCollapsed">
            <span class="switcher-name">{{ businessName }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="switcher-chevron">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </ng-container>
        </div>

        <div class="header-icons" *ngIf="!effectivelyCollapsed">
          <div class="header-icon-btn" (click)="toggleSidebar()" matTooltip="Collapse" matTooltipPosition="below">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="18" height="18" x="3" y="3" rx="2" />
              <path d="M9 3v18" />
              <path d="m14 9-3 3 3 3" />
            </svg>
          </div>
        </div>

        <!-- Business switcher dropdown -->
        <div class="switcher-panel" *ngIf="isBusinessSwitcherOpen" [style.left.px]="effectivelyCollapsed ? 60 : 8">
          <div class="switcher-panel-label">Businesses</div>
          <div class="switcher-panel-list">
            <ng-container *ngIf="!businessList?.length">
              <div class="switcher-row" *ngFor="let i of [1,2,3]">
                <div class="custom-skeleton custom-skeleton-circle" style="width:22px;height:22px;"></div>
                <div class="custom-skeleton" style="height:12px;flex:1;"></div>
              </div>
            </ng-container>
            <div class="switcher-row" *ngFor="let biz of businessList" (click)="onBusinessSwitcherSelect(biz)">
              <div class="switcher-row-tile">
                <img *ngIf="biz.logo" [src]="biz.logo" alt="">
                <span *ngIf="!biz.logo">{{ biz.name?.charAt(0) | uppercase }}</span>
              </div>
              <span class="switcher-row-name">{{ biz.name | titlecase }}</span>
              <svg *ngIf="biz.id === businessId" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="switcher-row-check">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>
          </div>
          <div class="switcher-panel-divider"></div>
          <div class="switcher-panel-action" (click)="onCreateBusiness()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            <span>Create Business</span>
          </div>
          <div class="switcher-panel-action" (click)="onListBusiness()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
            <span>All Businesses</span>
          </div>
          <div class="switcher-panel-action" (click)="onManageBusiness()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path
                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z" />
            </svg>
            <span>Manage</span>
          </div>
        </div>
      </div>

      <!-- Scrollable middle: primary nav + Projects/Chat History + Apps, one scroll region -->
      <div class="sidebar-scroll">

        <!-- Primary nav (top) -->
        <div class="nav-primary">

          <div class="sidebar-item chip-item" [class.active]="askSimpoActive()" (click)="goAskSimpo()"
            [matTooltip]="effectivelyCollapsed ? 'New Task' : ''" matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path
                  d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
              </svg>
            </span>
            <span class="tab-label" *ngIf="!effectivelyCollapsed">New Task</span>
          </div>

          <div class="sidebar-item" [class.active]="askSimpoActive('prospects')"
            (click)="goAskSimpo('prospects')"
            [matTooltip]="effectivelyCollapsed ? 'Generate leads' : ''" matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="7" />
                <path d="m20 20-4-4" />
                <path d="M11 8v6M8 11h6" />
              </svg>
            </span>
            <span class="tab-label" *ngIf="!effectivelyCollapsed">Generate leads</span>
          </div>

          <div class="sidebar-item" [class.active]="askSimpoActive('assistants')" (click)="goAssistants()"
            [matTooltip]="effectivelyCollapsed ? 'Assistants' : ''" matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M7.5 8C4.5 8 3 10 3 12s1.5 4 4.5 4
                   c2.5 0 3.5-4 4.5-4s2 4 4.5 4
                   c3 0 4.5-2 4.5-4s-1.5-4-4.5-4
                   c-2.5 0-3.5 4-4.5 4s-2-4-4.5-4Z" />
                <path d="M12 3v2" />
                <path d="M12 19v2" />
              </svg>
            </span>
            <span class="tab-label" *ngIf="!effectivelyCollapsed">Assistants</span>
          </div>

          <div class="sidebar-item" [class.active]="askSimpoActive('artifacts')" (click)="goAskSimpo('artifacts')"
            [matTooltip]="effectivelyCollapsed ? 'Library' : ''" matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m16 6 4 14" />
                <path d="M12 6v14" />
                <path d="M8 8v12" />
                <path d="M4 4v16" />
              </svg>
            </span>
            <span class="tab-label" *ngIf="!effectivelyCollapsed">Library</span>
          </div>

          <div class="sidebar-item" [class.active]="meetActive()" (click)="goMeet()"
            [matTooltip]="effectivelyCollapsed ? 'Meet' : ''" matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </span>
            <span class="tab-label" *ngIf="!effectivelyCollapsed">Meet</span>
          </div>

          <!-- Projects (collapsible section) -->
          <div class="section-header" *ngIf="!effectivelyCollapsed" (click)="toggleProjects(); goAskSimpo('projects')">
            <span>Projects</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="chevron" [class.open]="projectsOpen" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>

          <div class="as-list" *ngIf="!effectivelyCollapsed && projectsOpen">

            <ng-container *ngIf="projectsLoading && projects.length === 0">
              <div class="custom-skeleton as-skeleton-row" *ngFor="let i of [1,2,3,4,5]"></div>
            </ng-container>

            <div class="as-empty as-retry" *ngIf="projectsError && projects.length === 0" (click)="reloadProjects()">
              Couldn't load projects. Retry
            </div>

            <div class="as-empty" *ngIf="projectsLoaded && !projectsLoading && !projectsError && projects.length === 0">
              No projects yet
            </div>

            <ng-container *ngIf="projects.length > 0">
              <div class="sidebar-item as-row" *ngFor="let project of visibleProjects"
                (click)="openAskSimpoProject(project)" [class.deleting]="projectsDeletingId === project.id">
                <span class="tab-label">{{ project.name || 'Untitled' }}</span>
                <div class="star-icon" [class.starred]="project.starred"
                  [class.busy]="projectsStarringId === project.id" (click)="toggleProjectStar(project, $event)"
                  [matTooltip]="project.starred ? 'Unstar' : 'Star'" matTooltipPosition="right">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                    [attr.fill]="project.starred ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path
                      d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.99a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 10.774a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                </div>
                <div class="delete-icon" (click)="confirmDeleteProject(project, $event)" matTooltip="Delete"
                  matTooltipPosition="right">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 6h18" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <line x1="10" x2="10" y1="11" y2="17" />
                    <line x1="14" x2="14" y1="11" y2="17" />
                  </svg>
                </div>
              </div>
              <div class="as-show-more" *ngIf="hasMoreProjects" (click)="showMoreProjects()">Show more</div>
            </ng-container>

          </div>

          <div class="sidebar-item" *ngIf="effectivelyCollapsed" (click)="goAskSimpo('projects')" matTooltip="Projects"
            matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
              </svg>
            </span>
          </div>

          <!-- Chat History (collapsible section) -->
          <div class="section-header" *ngIf="!effectivelyCollapsed" (click)="toggleChatHistory(); goAskSimpo('chats')">
            <span>Chat History</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="chevron" [class.open]="chatHistoryOpen" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>

          <div class="as-list" *ngIf="!effectivelyCollapsed && chatHistoryOpen">

            <ng-container *ngIf="chatsLoading && chats.length === 0">
              <div class="custom-skeleton as-skeleton-row" *ngFor="let i of [1,2,3,4,5]"></div>
            </ng-container>

            <div class="as-empty as-retry" *ngIf="chatsError && chats.length === 0" (click)="reloadChats()">
              Couldn't load chats. Retry
            </div>

            <div class="as-empty" *ngIf="chatsLoaded && !chatsLoading && !chatsError && chats.length === 0">
              No chats yet
            </div>

            <ng-container *ngIf="chats.length > 0">
              <div class="sidebar-item as-row" *ngFor="let chat of visibleChats" (click)="openChat(chat)"
                [class.deleting]="chatsDeletingId === chat.id">
                <span class="tab-label">{{ chat.title || 'New chat' }}</span>
                <div class="delete-icon" (click)="confirmDeleteChat(chat, $event)" matTooltip="Delete"
                  matTooltipPosition="right">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 6h18" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <line x1="10" x2="10" y1="11" y2="17" />
                    <line x1="14" x2="14" y1="11" y2="17" />
                  </svg>
                </div>
              </div>
              <div class="as-show-more" *ngIf="hasMoreChats" (click)="showMoreChats()">Show more</div>
            </ng-container>

          </div>

          <div class="sidebar-item" *ngIf="effectivelyCollapsed" (click)="goAskSimpo('chats')" matTooltip="Chat History"
            matTooltipPosition="right">
            <span class="nav-ico">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </span>
          </div>

        </div><!-- /nav-primary -->

        <div class="mid-layer">

          <!-- Apps section header -->
          <div class="section-header apps-header" *ngIf="!effectivelyCollapsed && !isLoading" (click)="toggleApps()">
            <span class="apps-title">Apps
              <svg xmlns="http://www.w3.org/2000/svg" class="chevron" [class.open]="appsOpen" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m6 9 6 6 6-6" />
              </svg>
            </span>
            <span class="apps-actions" (click)="$event.stopPropagation()">
              <!-- Search -->
              <button type="button" class="apps-action-btn" [class.active]="isAppSearchOpen" matTooltip="Search apps"
                (click)="toggleAppSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.3-4.3" />
                </svg>
              </button>
              <!-- Filter -->
              <button type="button" class="apps-action-btn" [class.active]="isAppFilterOpen || appFilter !== 'all'"
                matTooltip="Filter apps" (click)="toggleAppFilter($event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 7h16" />
                  <path d="M7 12h10" />
                  <path d="M10 17h4" />
                </svg>
                <span class="filter-dot" *ngIf="appFilter !== 'all'"></span>
              </button>
              <!-- Add apps -->
              <button type="button" class="apps-action-btn" *ngIf="isStaffAdmin || hasAppPermission"
                matTooltip="Add apps" (click)="goToAddApps()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14" />
                  <path d="M12 5v14" />
                </svg>
              </button>
            </span>
          </div>

          <!-- Filter popover -->
          <div class="app-filter-panel" *ngIf="isAppFilterOpen && !effectivelyCollapsed" [style.top.px]="appFilterTop"
            [style.left.px]="8">
            <div class="app-filter-title">Show</div>
            <div class="app-filter-row" *ngFor="let opt of appFilterOptions" [class.selected]="appFilter === opt.value"
              (click)="selectAppFilter(opt.value)">
              <span class="app-filter-icon" [ngSwitch]="opt.value">
                <svg *ngSwitchCase="'all'" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="7" height="7" rx="1.5" />
                  <rect x="14" y="3" width="7" height="7" rx="1.5" />
                  <rect x="3" y="14" width="7" height="7" rx="1.5" />
                  <rect x="14" y="14" width="7" height="7" rx="1.5" />
                </svg>
                <svg *ngSwitchCase="'pinned'" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M12 17v5" />
                  <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16h14v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                </svg>
                <svg *ngSwitchCase="'unpinned'" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M12 17v5" />
                  <path d="M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89" />
                  <path d="m2 2 20 20" />
                  <path d="M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16h11" />
                </svg>
              </span>
              <span class="app-filter-label">{{ opt.label }}</span>
              <svg *ngIf="appFilter === opt.value" class="app-filter-check" xmlns="http://www.w3.org/2000/svg"
                width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>
          </div>

          <!-- Search Bar (expanded) -->
          <div class="sidebar-search" *ngIf="!effectivelyCollapsed && isAppSearchOpen">
            <div class="search-input-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="search-icon">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
              <input type="text" id="sidebarAppSearchInput" class="search-input" placeholder="Search apps..."
                [(ngModel)]="sidebarSearchQuery" (keydown.escape)="toggleAppSearch()" />
            </div>
          </div>

          <!-- Search Bar (collapsed) -->
          <div class="sidebar-search-collapsed" *ngIf="effectivelyCollapsed">
            <div class="collapsed-search-icon" (click)="isCollapsed = false; isAppSearchOpen = true">

              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="search-icon">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
            </div>
          </div>


          <!-- Skeleton Loader for Apps -->
          <ng-container *ngIf="isLoading">
            <div class="app-groups mt-2">
              <div *ngFor="let i of [1,2,3,4,5]" class="sidebar-item"
                style="pointer-events: none; padding: 8px 12px; margin-bottom: 4px; display: flex; align-items: center; gap: 12px;">
                <div class="custom-skeleton custom-skeleton-circle" style="width: 20px; height: 20px; flex-shrink: 0;">
                </div>
                <div class="tab-label w-100" *ngIf="!effectivelyCollapsed" style="display: flex; align-items: center;">
                  <div class="custom-skeleton" style="width: 65%; height: 14px;"></div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Flat apps list: no Pinned/All-apps split, no category groups -->
          <ng-container *ngIf="!isLoading && (appsOpen || effectivelyCollapsed)">
            <ng-container *ngIf="(sideNavData | sidebarSearch: sidebarSearchQuery : appFilter) as filteredApps">
              <div class="app-groups" *ngIf="filteredApps.length > 0 && hasVisibleApp(filteredApps)">
                <ng-container *ngFor="let item of filteredApps">
                  <div class="sidebar-item" [class.active]="item.status"
                    *ngIf="!item.hasOwnProperty('show') || item.show" (click)="expandPanelV2(item)"
                    [matTooltip]="effectivelyCollapsed ? (item.displayName || item.appName) : ''"
                    matTooltipPosition="right">

                    <div class="icon-wrapper" [ngClass]="{ 'active': item.status }"
                      [ngStyle]="{ '--icon-img': 'url(' + logo[item.appName] + ')' }">
                    </div>

                    <!-- Label -->
                    <span class="tab-label" *ngIf="!effectivelyCollapsed">
                      {{ item.displayName || item.appName }}
                    </span>

                    <!-- Count badge -->
                    <span class="nav-badge" *ngIf="!effectivelyCollapsed && item.count > 0">{{ item.count }}</span>

                    <!-- Pin icon (hide for Home/Dashboard) -->
                    <div *ngIf="!effectivelyCollapsed && (item.displayName || item.appName)?.toLowerCase() !== 'home'"
                      class="pin-icon" (click)="markAppPinned(item); $event.stopPropagation()"
                      [matTooltip]="item.favorite ? 'Unpin' : 'Pin'" matTooltipPosition="right">
                      <svg *ngIf="!item.favorite" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="pin-svg">
                        <path d="M12 17v5" />
                        <path
                          d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                      </svg>
                      <svg *ngIf="item.favorite" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="pin-svg pinned">
                        <path d="M12 17v5" />
                        <path
                          d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
                      </svg>
                    </div>

                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

        </div><!-- /mid-layer -->
      </div><!-- /sidebar-scroll -->

      <!-- Footer -->
      <div class="footer-layer">
        <!-- Create Business -->
        <!-- <div class="add-apps-btn" *ngIf="!effectivelyCollapsed" (click)="navigateToBusinessCreation()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="add-icon">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
          <span>Create business</span>
        </div>
        <div class="add-apps-btn add-apps-collapsed" *ngIf="effectivelyCollapsed" matTooltip="Create business"
          matTooltipPosition="right" (click)="navigateToBusinessCreation()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="add-icon">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </div> -->
        <!-- Add Apps now lives in the Apps header (+ icon) -->

        <!-- Identity row: avatar+name (profile), notifications -->
        <div class="footer-identity-row">
          <div class="identity-trigger" (click)="toggleProfilePanel()" (mouseenter)="onPopoverHoverEnter('profile')"
            (mouseleave)="onPopoverHoverLeave()">
            <div class="identity-avatar">{{ staffName?.charAt(0) | uppercase }}</div>
            <span class="identity-name" *ngIf="!effectivelyCollapsed">{{ staffName | titlecase }}</span>
          </div>
          <div class="footer-icon-btn footer-bell" *ngIf="!effectivelyCollapsed" (click)="toggleNotificationPopover()"
            (mouseenter)="onPopoverHoverEnter('notif')" (mouseleave)="onPopoverHoverLeave()"
            [attr.aria-label]="unseenCount > 0 ? unseenCount + ' unread notifications' : 'Notifications'">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
              <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
            </svg>
            <div class="nav-dot" *ngIf="unseenCount > 0"></div>
          </div>
        </div>

        <!-- Notification popover: flat list, no tabs/date-grouping -->
        <div class="notif-panel" *ngIf="isNotificationPopoverOpen" [style.left.px]="effectivelyCollapsed ? 60 : 8"
          (mouseenter)="onPopoverHoverStay()" (mouseleave)="onPopoverHoverLeave()">
          <div class="notif-panel-header">
            <span>Notifications</span>
            <span class="notif-mark-read" *ngIf="unseenCount > 0" (click)="onMarkAllRead($event)">Mark all as
              read</span>
          </div>
          <div class="notif-panel-list">
            <div class="notif-empty" *ngIf="!notifications?.length">No notifications yet</div>
            <div class="notif-row" *ngFor="let n of notifications" (click)="onNotificationRowClick(n)">
              <div class="notif-icon" [ngSwitch]="getNotificationIconType(n.notificationFor)">
                <svg *ngSwitchCase="'user'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <svg *ngSwitchCase="'calendar'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <svg *ngSwitchCase="'list'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <line x1="8" y1="6" x2="21" y2="6" />
                  <line x1="8" y1="12" x2="21" y2="12" />
                  <line x1="8" y1="18" x2="21" y2="18" />
                  <line x1="3" y1="6" x2="3.01" y2="6" />
                  <line x1="3" y1="12" x2="3.01" y2="12" />
                  <line x1="3" y1="18" x2="3.01" y2="18" />
                </svg>
                <svg *ngSwitchCase="'message'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <svg *ngSwitchCase="'megaphone'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="m3 11 18-5v12L3 14v-3z" />
                  <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
                </svg>
                <svg *ngSwitchCase="'phone'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <svg *ngSwitchCase="'document'" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="3" />
                  <path
                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
              </div>
              <div class="notif-content">
                <div class="notif-title">{{ n.title | titlecase }}</div>
                <div class="notif-desc">{{ n.description }}</div>
                <div class="notif-time">{{ n.createdDate | relativeTime }}</div>
              </div>
              <div class="notif-unread-dot" *ngIf="!n.seen"></div>
            </div>
          </div>
        </div>

        <!-- Profile popup: same fixed-popover mechanics as the notification popup -->
        <div class="profile-panel" *ngIf="isProfilePanelOpen" [style.left.px]="effectivelyCollapsed ? 60 : 8"
          (mouseenter)="onPopoverHoverStay()" (mouseleave)="onPopoverHoverLeave()">
          <div class="profile-user-card">
            <div class="profile-avatar">{{ staffName?.charAt(0) | uppercase }}</div>
            <div class="profile-user-details">
              <div class="profile-user-name">{{ staffName | titlecase }}</div>
              <div class="profile-user-role">{{ getProfileStaffType() }}</div>
            </div>
          </div>

          <!-- Real balance/nav logic stays in CreditBalanceComponent; we just read its
               public state via #creditRef instead of rendering its own top-bar-shaped
               template (a dot+stack+arrow pill), which is why this looked so cramped.
               Both elements share one ng-container's *ngIf so #creditRef is visible
               to the sibling div (a template ref only resolves within its own
               embedded view — two separate *ngIfs would be two separate scopes). -->
          <ng-container *ngIf="businessId">
            <app-credit-balance #creditRef [organizationId]="businessId"
              class="profile-credits-source"></app-credit-balance>
            <div class="profile-credits-card" (click)="creditRef.onCreditsClick()">
              <div class="profile-credits-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <span class="profile-credits-label">Credits</span>
              <span class="profile-credits-value" [class.low]="creditRef.isLowBalance">{{ creditRef.displayCredits |
                number }}</span>
            </div>
          </ng-container>
          <button type="button" class="profile-upgrade-btn" (click)="openManageBilling()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path
                d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
            </svg>
            <span>Upgrade</span>
          </button>

          <div class="profile-divider"></div>

          <div class="profile-menu-item" (click)="onReferClick()">
            <span class="profile-menu-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" x2="19" y1="8" y2="14" />
                <line x1="22" x2="16" y1="11" y2="11" />
              </svg>
            </span>
            <span>Refer a business</span>
          </div>
          <div class="profile-menu-item" (click)="onWhatsNewClick()">
            <span class="profile-menu-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
              </svg>
            </span>
            <span>What's New?</span>
          </div>
          <div class="profile-menu-item" *ngIf="canAccessProfileSettings" (click)="goToProfileSettings()">
            <span class="profile-menu-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3" />
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z" />
              </svg>
            </span>
            <span>Settings</span>
          </div>

          <div class="profile-divider"></div>

          <div class="profile-menu-item profile-logout" (click)="requestLogout()">
            <span class="profile-menu-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" x2="9" y1="12" y2="12" />
              </svg>
            </span>
            <span>Log out</span>
          </div>
        </div>

      </div>

    </div><!-- /main-sidebar -->


    <!-- Sub Panel -->
    <div class="sub-panel" [ngClass]="{'sub-collapsed': isSubPanelCollapsed}"
      *ngIf="hasSubPanel">
      <div class="sub-panel-header">
        <div class="app-header-icon" [ngStyle]="{ '--icon-img': 'url(' + logo[activeSubApp.appName] + ')' }"
          [matTooltip]="isSubPanelCollapsed ? (activeSubApp.displayName || activeSubApp.appName) : ''"
          matTooltipPosition="right"></div>
        <div class="header-breadcrumb" *ngIf="!isSubPanelCollapsed">
          <span class="app-name-text">{{ (activeSubApp.displayName || activeSubApp.appName) | titlecase }}</span>
          <ng-container *ngFor="let sub of activeSubApp.subAppName">
            <ng-container *ngIf="sub.status">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="breadcrumb-chevron">
                <path d="m9 18 6-6-6-6" />
              </svg>
              <span class="sub-name-text">{{ (sub.displayName || sub.subAppName) | titlecase }}</span>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="sub-panel-list">
        <ng-container *ngFor="let sub of activeSubApp.subAppName">
          <div *ngIf="!sub.hasOwnProperty('show') || sub.show" class="sub-panel-item"
            [ngClass]="{ 'active-sub': sub.status }" (click)="changeSubPanel(activeSubApp, sub)"
            [matTooltip]="isSubPanelCollapsed ? (sub.displayName || sub.subAppName) : ''" matTooltipPosition="right">

            <div *ngIf="!sub.icon" class="sub-item-icon" [ngClass]="{ active: sub.status }"
              [ngStyle]="{ '--icon-img': 'url(' + logo[sub.subAppName] + ')' }">
            </div>
            <svg *ngIf="sub.icon" class="sub-item-inline-icon" xmlns="http://www.w3.org/2000/svg" width="18"
              height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
              stroke-linecap="round" stroke-linejoin="round">
              <path [attr.d]="sub.icon"></path>
            </svg>

            <div class="name-text" *ngIf="!isSubPanelCollapsed">
              {{ (sub.displayName || sub.subAppName) | titlecase }}
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Collapse Section -->
      <div class="sub-panel-collapse" (click)="toggleSubPanel()">
        <svg *ngIf="!isSubPanelCollapsed" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="collapse-panel-icon">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
          <path d="M9 3v18" />
          <path d="m16 15-3-3 3-3" />
        </svg>
        <span class="collapse-text" *ngIf="!isSubPanelCollapsed">Collapse</span>

        <svg *ngIf="isSubPanelCollapsed" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="collapse-panel-icon" matTooltip="Expand" matTooltipPosition="right">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
          <path d="M9 3v18" />
          <path d="m14 9 3 3-3 3" />
        </svg>
      </div>
    </div>

  </div>

</ng-container>

<!-- Business Info template (used in mobile) -->
<ng-template #BusinessInfo>
  <div class="top_layer">
    <div class="business_name dropdown">
      <div class="profile dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown"
        aria-expanded="false">
        <div class="tag_name">
          <div class="business_tag" *ngIf="!bDetails?.logo">
            {{businessName.split('')[0] | uppercase}}
          </div>
          <img [src]="bDetails?.logo" alt="" *ngIf="bDetails?.logo" class="logo-img">
          <div class="left_bar" (click)="goToListing()">
            <div class="left_bar_sub">
              <div class="business_title">
                {{businessName | limitToPipe : 9 | titlecase}}{{businessName.length > 9 ? '' : ''}}
              </div>
            </div>
            <div class="business_type">
              {{bDetails?.subIndustryName | limitToPipe : 18}}{{bDetails?.subIndustryName > 18 ? '...' : ''}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Mobile view -->
<ng-container *ngIf="screenWidth < 475">
  <div class="mobile_screen">
    <ng-container *ngTemplateOutlet="BusinessInfo"></ng-container>
    <div class="top_section">
      <div *ngFor="let item of sideNavData; index as i">
        <div class="mobile_tab" (click)="expandPanel(item)">
          <div class="img_name">
            <div class="img_url">
              <img src="./../../../../assets/images/sidepanel/{{((item.name).split(' ').join('_')).toLowerCase()}}.svg"
                alt="icon" *ngIf="!item.status">
              <img
                src="./../../../../assets/images/sidepanel/{{((item.name).split(' ').join('_')).toLowerCase()}}_active.svg"
                alt="icon" *ngIf="item.status">
            </div>
            <div [ngClass]="item.status ? 'tab_name_active' : 'tab_name'">
              {{item.name}}
            </div>
          </div>
          <div class="arrow" *ngIf="item.subArray.length > 0">
            <mat-icon *ngIf="!item.status">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="item.status">keyboard_arrow_up</mat-icon>
          </div>
        </div>
        <div class="second-panel" *ngIf="item.subArray.length > 0 && item.status">
          <ng-container *ngFor="let subPanel of item.subArray">
            <div class="second_panel_data"
              [ngClass]="subPanel.status ? 'second_panel_data_active' : 'second_panel_data'"
              (click)="subDataClick(item.name,subPanel)">
              <img src="./../../../../assets/images/sidepanel/dot.svg" alt="dot" class="dot_icon"
                *ngIf="subPanel.status">
              <div class="name">
                {{subPanel.name}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="last_layer">
      <div class="lite_hr_line"></div>
      <div class="bottom_single_tab_1" (click)="businessDetails()">
        <div class="img_name">
          <div class="sub_img_url">
            <img src="./../../../../assets/images/sidepanel/account.svg" alt="accounts image">
          </div>
          <div class="name_icon">
            <div class="tab_name">
              Business
            </div>
            <div class="sub_text">
              Manage Business
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #BusinessListPopup>
  <div class="show_list_business">
    <ul class="dropdown-menu">
      <div class="title_manage">
        <div class="popup_title">Your Businesses</div>
        <div class="closing_bar" id="closeBottomSheet" data-bs-dismiss="offcanvas" data-bs-target="#addPageBottomSheet"
          aria-label="Close"><mat-icon>close</mat-icon></div>
      </div>

      <div class="list_business">
        <ng-container *ngFor="let item of allBusiness">
          <div class="heading_section" (click)="switchBusiness(item)" style="cursor: pointer">
            <div class="heading" [style.color]="item.status ? '#0496FF' : ''">
              {{item.name}}
            </div>
            <div class="done_btn">
              <button class="home-icon"><mat-icon
                  [style.color]="item.status ? '#0496FF' : ''">keyboard_arrow_right</mat-icon></button>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="create_btn">
        <button class="manage-business" (click)="businessDetails()"><img
            src="../../../../assets/images/sidepanel/manage_business.svg" alt="">Manage</button>
        <button class="create-business" (click)="createNewBusiness()">Create New</button>
      </div>
    </ul>
  </div>
</ng-template>

<ng-template #loadingSkeleton>
  <div *ngFor="let i of [1,1,1]">
    <div class="d-flex align-items-center gap-3">
      <ngx-skeleton-loader count="1" appearance="circle"
        style="width: 40px; height: 40px; margin-bottom: 10px;"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" style="width: 150px; height: 15px;"></ngx-skeleton-loader>
    </div>
    <div class="skelton-main">
      <ngx-skeleton-loader count="1"
        style="width: 100px; height: 15px; margin-left:23%; margin-bottom: 10px;"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1"
        style="width: 100px; height: 15px; margin-left:23%; margin-bottom: 10px;"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1"
        style="width: 100px; height: 15px; margin-left:23%; margin-bottom: 10px;"></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
